<template>
  <span class="flicker live-counter" :class="computedClasses">
    <slot></slot>
    {{ hasSlots ? '' : cellValue }}
  </span>
</template>

<script>
export default {
  name: 'LiveCounter',
  props: {
    cellValue: {
      type: Number,
      default: 0,
    },
    customClass: {
      type: String,
      default: '',
    },
    flickerClass: {
      type: String,
      default: '',
    },
  },
  watch: {
    cellValue(newValue, oldValue) {
      if (oldValue !== undefined && newValue !== oldValue) {
        this.increaseDecreaseValue(newValue, oldValue);
        setTimeout(() => {
          this.increaseValue = null;
        }, 3000);
      }
    },
  },
  computed: {
    computedClasses() {
      const classes = [];
      if (this.increaseValue === true) classes.push('increase');
      if (this.increaseValue === false) classes.push('decrease');
      if (classes.length > 0) classes.push(this.flickerClass);

      if (this.customClass) {
        classes.push(this.customClass);
      }

      return classes;
    },
    hasSlots() {
      return this.$slots.default && this.$slots.default.length > 0;
    },
  },
  methods: {
    increaseDecreaseValue(current, previous) {
      if (current > previous) {
        this.increaseValue = true;
      } else if (current < previous) {
        this.increaseValue = false;
      }
    },
  },
  data() {
    return {
      increaseValue: null,
    };
  },
};
</script>

<style></style>
